import { StyleSheet } from 'react-native';
import { colors, sizes } from '~/values';


const styles = StyleSheet.create({
  container: {
    padding: sizes.horizontalSpacing,
    borderBottomColor: colors.grayContainerDark,
    borderBottomWidth: 3,
    backgroundColor: '#FFF',
  },
  title: {
    color: colors.primaryColor,
    fontSize: sizes.textLittleBig,
    fontWeight: '500',
    marginBottom: sizes.horizontalSpacing,
  },
});

export default styles;
